import * as React from 'react';
export const eloSvg = React.forwardRef(function eloSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#003933',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.83 15.228h2.094c.375-1.989 2.108-3.59 4.316-3.59 2.512 0 4.274 1.788 4.274 4.484 0 .288-.03.52-.058.721H5.699c.318 1.226 1.328 1.947 2.541 1.947 1.04 0 1.819-.404 2.44-1.11l1.242 1.139c-.823.936-2.05 1.585-3.682 1.585a4.37 4.37 0 0 1-4.317-3.56H1.83v-1.616Zm8.893 0a2.419 2.419 0 0 0-.65-1.297c-.432-.433-1.068-.706-1.833-.706-.765 0-1.386.26-1.848.72-.317.318-.577.75-.707 1.284h5.038Zm3.047-3.532h1.819v6.92h3.291v1.73h-3.262c-1.199 0-1.848-.648-1.848-1.845v-6.805Zm5.457 4.325c0-2.35 1.92-4.382 4.461-4.382 2.253 0 4.014 1.586 4.39 3.59h2.093v1.615h-2.094a4.437 4.437 0 0 1-4.389 3.56c-2.555 0-4.46-2.018-4.46-4.383Zm4.461 2.682c1.516 0 2.642-1.153 2.642-2.667 0-1.5-1.155-2.696-2.642-2.696-1.515 0-2.642 1.153-2.642 2.681 0 1.485 1.155 2.682 2.642 2.682Z',
      fill: '#fff',
    }),
  );
});
eloSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var elo = {
  category: 'brand',
  colorable: false,
  name: 'elo',
  svg: eloSvg,
};
